import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  CircularProgress,
  Alert
} from '@mui/material';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import preInscricaoStatusService from '../../services/preInscricaoStatusService';

const StatusHistorico = ({ preInscricaoId }) => {
  const [historico, setHistorico] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const carregarHistorico = async () => {
      try {
        const response = await preInscricaoStatusService.obterHistorico(preInscricaoId);
        setHistorico(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Erro ao carregar histórico:', err);
        setError('Não foi possível carregar o histórico de status');
        setLoading(false);
      }
    };

    carregarHistorico();
  }, [preInscricaoId]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ m: 2 }}>
        {error}
      </Alert>
    );
  }

  if (historico.length === 0) {
    return (
      <Typography color="text.secondary" sx={{ p: 2 }}>
        Nenhuma alteração de status registrada.
      </Typography>
    );
  }

  return (
    <List sx={{ width: '100%', maxWidth: 600, bgcolor: 'background.paper' }}>
      {historico.map((item, index) => (
        <React.Fragment key={index}>
          <ListItem alignItems="flex-start">
            <ListItemText
              primary={
                <Typography variant="subtitle1">
                  De: <strong>{item.statusAnterior}</strong> → Para: <strong>{item.statusNovo}</strong>
                </Typography>
              }
              secondary={
                <>
                  <Typography
                    variant="body2"
                    color="text.primary"
                    sx={{ mt: 1 }}
                  >
                    {format(new Date(item.createdAt), "dd 'de' MMMM 'de' yyyy 'às' HH:mm", {
                      locale: ptBR
                    })}
                  </Typography>
                  {item.observacao && (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mt: 1 }}
                    >
                      Observação: {item.observacao}
                    </Typography>
                  )}
                </>
              }
            />
          </ListItem>
          {index < historico.length - 1 && <Divider component="li" />}
        </React.Fragment>
      ))}
    </List>
  );
};

StatusHistorico.propTypes = {
  preInscricaoId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired
};

export default StatusHistorico;